import { httpClientPrivate } from '@/libs/httpClient'
import config from '@/config'
import { useMutation } from '@tanstack/react-query'

const postAcceptTask = async (claimFormId: string) => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}/accept-task`,
  )
  return response.data
}

const useAcceptTask = (claimFormId: string) => {
  const mutation = useMutation({
    mutationKey: ['useAcceptTask', claimFormId],
    mutationFn: async () => postAcceptTask(claimFormId),
  })

  return mutation
}

export { postAcceptTask, useAcceptTask }
